// extracted by mini-css-extract-plugin
export default {"section":"section--owuGp","title":"title--ZtSFI","content":"content--JxgCg","text":"text--aB3Pd"};